import { Component } from "@angular/core";

@Component({
    templateUrl: "./not-found.component.html"
})

export class NotFoundComponent {}


// WEBPACK FOOTER //
// ./src/app/not-found/not-found.component.ts